/* eslint-disable react/react-in-jsx-scope */
import { h } from "preact";
import { useState } from "preact/hooks";

import hideIcon from "../../assets/icons/hide.svg";
import viewIcon from "../../assets/icons/view.svg";

import "./styles.scss";

export const PasswordInput = ({
  value,
  onChange,
  placeholder,
  className,
}: {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  placeholder?: string;
}): JSX.Element => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="pswdWrapper">
      <input
        className={className ?? "pswd"}
        type={showPassword ? "text" : "password"}
        value={value}
        onChange={(evt) => onChange(evt.currentTarget.value)}
        name="password"
        placeholder={placeholder ?? "Create password 8+ characters*"}
        autoComplete="false"
      />
      <img
        src={showPassword ? hideIcon : viewIcon}
        alt="view indicator"
        onClick={() => setShowPassword(!showPassword)}
      />
    </div>
  );
};
